"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ON_ELECTRON_FOCUS = exports.ON_WINDOW_FOCUS = void 0;
exports.ON_WINDOW_FOCUS = '@platform/ON_WINDOW_FOCUS';
exports.ON_ELECTRON_FOCUS = '@platform/ON_ELECTRON_FOCUS';